import { FormattedMessage } from 'react-intl';
import React from 'react';

export const UserListError: React.FC = () => (
  <p className="alert alert--note s-top--med">
    <FormattedMessage id="errors.users" />
  </p>
);
